<!--
/*******************************************************************************
*@ 컴포넌트명   : AccountBox.vue
*@ 컴포넌트설명 : 계좌내역 목록
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <template v-if="siteCode != $config.SITECODE_OGMMR && fatcaBilnTagetDstcd == '1'">
      <div class="info info-import" @click="openedFatca = true">
        <i class="icon icon-import" />
        {{ /*고객님은 FATCA 확인서 제출 대상입니다.*/ $t("MCOM-01-01-03-01") }}
        <i class="icon icon-arrow-s-right" />
      </div>
    </template>
    <div class="box-white -type4" :class="{ 'mtop-16': i == '0' && !(siteCode != $config.SITECODE_OGMMR && fatcaBilnTagetDstcd == '1') }" v-for="(item, i) in acnList" :key="i">
      <!-- [HEADER] 알림영역 -->
      <div class="header">
        <div v-if="item.isAcnStusAlrm && item.isAcnStusAlrmShow" class="notice">
          <i class="icon icon-alarm" />
          <span v-if="item.acnStus == '1'" class="item">{{ /*계좌 거래 중지 상태입니다.*/ $t("MINQ-01-01-11-05") }}</span>
          <span v-else class="item">{{ /*대출 연체가 발생하였습니다.*/ $t("MINQ-01-01-14-05") }}</span>
          <i class="icon icon-close2" @click="closeNotice('1', item.acno, [item.acnStus])" />
        </div>
        <div v-else-if="item.isExpirAlrm && item.isExpirAlrmShow" class="notice">
          <i class="icon icon-alarm" />
          <span class="item">{{ item.acnDtailCd == "3" ? /*예금 만기가 지났습니다.*/ $t("MINQ-01-01-12-14") : /*적금 만기가 지났습니다.*/ $t("MINQ-01-01-12-05") }}</span>
          <i class="icon icon-close2" @click="closeNotice('2', item.acno, [item.expirYmd])" />
        </div>
        <div v-else-if="item.isNxtrmPaymtAlrm && item.isNxtrmPaymtAlrmShow" class="notice">
          <i class="icon icon-alarm" />
          <span class="item">{{ /*이자 납부일 일주일 전 입니다.*/ $t("MINQ-01-01-13-10") }}</span>
          <i class="icon icon-close2" @click="closeNotice('3', item.acno, [item.nxtrmPaymtYmd])" />
        </div>
        <div v-else-if="item.isLnExpirAlrm && item.isLnExpirAlrmShow" class="notice">
          <i class="icon icon-alarm" />
          <span class="item">{{ /*대출 만기일이 1개월 남았습니다.*/ $t("MINQ-01-01-13-05") }}</span>
          <i class="icon icon-close2" @click="closeNotice('4', item.acno, [item.lnExpirYmd])" />
        </div>
        <!-- 입출금 , 예적금 -->
        <template v-if="item.acnoKnd2 == '3' || item.acnoKnd2 == '4'">
          <div class="title">
            {{ item.acnoAls ? item.acnoAls : item.prdctName }}<span v-if="item.limtRsrctAcnoYn == 1" class="badge-limit">{{ /* 비대면 한도제한계좌 */ $t("EKYC-21-11") }}</span>
            <!-- 2차 개발영역 
            <i class="icon icon-setting" v-if="item.acnoKnd2 == '4' && !item.isExpirAlrm" />-->
          </div>
          <div class="desc">
            <div class="item account" @click="goAcnoDtl(item)">
              {{ `${item.acno} - ${item.prdctName}` }}
              <i class="icon icon-arrow-s-right" />
            </div>
          </div>
        </template>
        <!-- 대출 -->
        <template v-else>
          <div class="title">{{ item.acnoAls }}</div>
          <div class="desc">
            <div class="item account" @click="goAcnoDtl(item)">
              {{ `${item.acno} - ${/*대출 금리*/ $t("MMAIN-03-03-02-16")} ${item.lnIrt ? item.lnIrt : "0"}%` }}
              <i class="icon icon-arrow-s-right" />
            </div>
          </div>
        </template>
      </div>
      <!-- [CONTENT] 본문영역 -->
      <div class="content">
        <!-- 입출금 , 예적금 -->
        <template v-if="item.acnoKnd2 == '3' || item.acnoKnd2 == '4'">
          <div class="account-info -type3">
            <div class="item amount">
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="$num(item.bal, null, true)"></span>
            </div>
            <!-- page: termiUpdat 예금갱신 -->
            <template v-if="page == 'termiUpdat'">
              <div class="item sub">
                <div class="cont">
                  <span class="tit">{{ /*신규일*/ $t("MINQ-01-01-08-13") }}</span>
                  <span class="dec">{{ /*신규일자*/ $getGlobalDateFmt(item.newYmd) }}</span>
                </div>
                <div class="cont" v-if="item.acnDtailCd != '1' && item.acnDtailCd != '2'">
                  <span class="tit">{{ /*만기일자*/ $t("MINQ-01-01-08-14") }}</span>
                  <span :class="['dec', item.isExpirTermiBtn ? 'highlight' : '']">{{ /*만기일자*/ $getGlobalDateFmt(item.expirYmd) }}</span>
                </div>
                <div class="cont" v-if="item.acnDtailCd === '3'">
                  <span class="tit">{{ /*만기 설정*/ $t("MINQ-01-01-07-11") }}</span>
                  <span class="dec">{{ $t(`${item.dpostExpirPrcsDstcd}_예적금만기구분`) }}</span>
                </div>
                <div class="cont" v-if="item.acnDtailCd === '4'">
                  <span class="tit">{{ /*납입회차*/ $t("MINQ-01-01-08-15") }}</span>
                  <span class="dec">{{ item.paymtzNth }}/{{ item.totalPaymtzNth }}</span>
                </div>
              </div>
            </template>
            <!-- 그외 -->
            <template v-else>
              <div v-if="item.isAcnStusAlrm" class="item sub">
                <div class="cont">
                  <span class="tit">{{ /*계좌상태*/ $t("MINQ-01-01-08-22") }}</span>
                  <span class="dec wraning">{{ $t(`${item.acnStus}_계좌상태구분코드`) }}</span>
                </div>
              </div>
              <div v-else-if="item.isExpirAlrm" class="item sub">
                <div class="cont">
                  <span class="tit">{{ /*만기 설정*/ $t("MINQ-01-01-07-08") }}</span>
                  <span class="dec">{{ $t(`${item.dpostExpirPrcsDstcd}_예적금만기구분`) }}</span>
                </div>
                <div class="cont">
                  <span class="tit">{{ /*계좌상태*/ $t("MINQ-01-01-08-22") }}</span>
                  <span class="dec highlight">{{ /*만기*/ $t("MINQ-01-01-12-10") }}</span>
                </div>
              </div>
            </template>
          </div>
        </template>
        <!-- 대출 -->
        <template v-else>
          <div class="account-info -type3">
            <div class="item amount">
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="$num(item.lnBal, null, true)"></span>
            </div>
            <div v-if="item.acnStus == '2'" class="item sub">
              <div class="cont">
                <span class="tit">{{ /*다음납입일*/ $t("MINQ-01-01-09-10") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.nxtrmPaymtYmd) }}</span>
              </div>
              <div class="cont">
                <span class="tit">{{ /*계좌상태*/ $t("MINQ-01-01-08-22") }}</span>
                <span class="dec wraning">{{ $t(`${item.acnStus}_계좌상태구분코드`) }}</span>
              </div>
            </div>
            <div v-else-if="item.isNxtrmPaymtAlrm" class="item sub">
              <div class="cont">
                <span class="tit">{{ /*다음납입일*/ $t("MINQ-01-01-09-10") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.nxtrmPaymtYmd) }}</span>
              </div>
              <div class="cont">
                <span class="tit">{{ /*다음 이자 납입 금액*/ $t("MINQ-01-01-09-11") }}</span>
                <span class="dec">
                  <span class="exchange-unit">{{ item.cncycd }}</span>
                  <span class="total">{{ $num(item.nxtrmIntPaymtAmt) }}</span>
                </span>
              </div>
            </div>
            <div v-else-if="item.isLnExpirAlrm" class="item sub">
              <div class="cont">
                <span class="tit">{{ /*만기일*/ $t("MINQ-01-01-09-09") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.expirYmd) }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- [BOTTOM]] 하단버튼영역 -->
      <div class="bottom">
        <div class="btn-area--bottom">
          <!-- 입출금 -->
          <template v-if="item.acnoKnd2 == '3'">
            <button class="btn sm outline" @click="goTrascDtl(item)">{{ /*거래내역조회*/ $t("MINQ-01-01-05-06") }}</button>
            <button v-if="item.isTrsaccBtn" class="btn sm outline" :class="{ disabled: item.acnStus == '1' }" @click="onTrsacc(item)">
              {{ item.acnStus == "1" ? /*이체 불가*/ $t("MINQ-01-01-05-09") : /*이체*/ $t("MINQ-01-01-05-07") }}
            </button>
          </template>
          <!-- 예적금 -->
          <template v-else-if="item.acnoKnd2 == '4'">
            <button class="btn sm outline" v-if="page != 'termiUpdat'" @click="goTrascDtl(item)">{{ /*거래내역조회*/ $t("MINQ-01-01-05-06") }}</button>
            <button class="btn sm outline" v-if="item.isExpirTermiBtn && siteCode != $config.SITECODE_OGMMR && page == 'termiUpdat'" @click="termi(item)">
              {{ /*해지*/ $t("MDEP-02-01-01-09") }}
            </button>
            <button class="btn sm outline" v-if="item.isExpirTermiBtn2 && siteCode != $config.SITECODE_OGMMR && page == 'myAccount'" @click="termi(item)">
              {{ /*예금해지*/ $t("MCOM-0000066") }}
            </button>
            <button v-if="item.isAnticiInqBtn" class="btn sm outline" @click="goAnticiInq(item)">{{ /*해지예상조회*/ $t("MDEP-02-01-01-10") }}</button>
            <button class="btn sm outline highlight" v-if="item.isExpirUpdatBtn" @click="reNew(item)">{{ /*갱신*/ $t("MDEP-02-01-04-19") }}</button>
            <button v-if="item.isExpirBtn" class="btn sm outline highlight" @click="reNew(item)">{{ /*갱신신청*/ $t("MINQ-01-01-07-12") }}</button>
          </template>
          <!-- 대출 -->
          <template v-else>
            <template v-if="page == 'myAccount' || page == 'loansAccount'">
              <button class="btn sm outline" @click="goTrascDtl(item)">{{ /*거래내역조회*/ $t("MINQ-01-01-05-06") }}</button>
              <button class="btn sm outline" :class="{ highlight: item.isLnExpirAlrm }" @click="goLoans('lnamtRpayAnticiInq', item)">
                {{ /*대출금 상환*/ $t("MINQ-01-01-09-07") }}
              </button>
              <button class="btn sm outline" :class="{ highlight: item.acnStus == '2' || item.isNxtrmPaymtAlrm }" @click="goLoans('interestLoanPaymentView', item)">
                {{ /*이자 납부*/ $t("MLON-01-01-03-22") }}
              </button>
            </template>
            <template v-else></template>
          </template>
        </div>
      </div>
    </div>
    <div class="empty" v-if="!loading && acnList.length == 0">
      <div class="empty-img">
        <i class="icon icon-opt-no" />
      </div>
      <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
    </div>
    <!-- 계좌 상세 팝업 -->
    <account-detail-popup ref="accountDetailPopup" :page="page" :isExpirTermiBtn="isExpirTermiBtn" :isExpirUpdatBtn="isExpirUpdatBtn" />
    <!-- 알림 메시지 닫기 -->
    <modal-pop :opened.sync="acnoAlrtOpened" class="modal">
      <template #content>
        <div>{{ /*이 알림 메시지를 더이상 표시하지 않습니다.*/ $t("MINQ-01-01-15-02") }}</div>
      </template>
      <template #footer>
        <button class="btn bottom negative" @click="acnoAlrtOpened = !acnoAlrtOpened">{{ /*아니오*/ $t("MINQ-01-01-15-03") }}</button>
        <button class="btn bottom positive" @click="closeNoticeCfm()">{{ /*예*/ $t("MINQ-01-01-15-04") }}</button>
      </template>
    </modal-pop>
    <!-- 이체 메뉴 이동 -->
    <modal-pop :opened.sync="trsaccOpend" :btn-close="true" class="modal">
      <template #content>
        <div>{{ /*이체 메뉴로 이동하시겠습니까?*/ $t("MINQ-01-01-06-16") }}</div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="goTrsacc('1')">{{ /*당행이체*/ $t("MINQ-01-01-06-17") }}</button>
        <button class="btn bottom positive" @click="goTrsacc('2')">{{ /*타행이체*/ $t("MINQ-01-01-06-18") }}</button>
      </template>
    </modal-pop>
    <popup :opened.sync="popupOpened" :use-header="true" :use-footer="true" :title="/*예금해지 예상 조회*/ $t('MDEP-02-01-08-01')" class="popup">
      <template #content>
        <termi-antici-inq :acno="acno" :cncycd="cncycd" :acnOtPutNm="acnOtPutNm"></termi-antici-inq>
      </template>
      <template #footer>
        <div class="btn-area--full">
          <button class="btn md gray" v-if="isExpirTermiBtn" @click="goToTermi()">{{ /*해지*/ $t("MDEP-02-01-03-15") }}</button>
          <button class="btn md normal" @click="popupClose()">{{ /*확인*/ $t("MCOM-0000003") }}</button>
        </div>
      </template>
    </popup>
    <!-- FATCA 안내 -->
    <modal-pop :opened.sync="openedFatca" title="MCOM-01-01-03-02" class="modal" confirm="MCOM-0000003">
      <template #content>
        <div>
          {{ /*고객님은 미국 납세자 여부 확인을 위한 FATCA 확인서 제출 대상입니다.*/ $t("MCOM-01-01-03-03") }}
          <br />
          {{ /*미제출 시 비협조 고객으로 분류되어 고객님의 금융거래 정보가 국세청에 보고될 수 있습니다.*/ $t("MCOM-01-01-03-04") }}
          <br />
          {{
            isPersonalUser
              ? /*「인터넷 뱅킹 》개인뱅킹 》고객정보관리》해외납세 의무자 본인 확인서 조회/등록」메뉴에서 제출해주시기 바랍니다.*/ $t("MCOM-01-01-03-05")
              : /*「인터넷 뱅킹 》기업뱅킹 》고객정보관리》해외납세 의무자 본인 확인서 조회/등록」메뉴에서 제출해주시기 바랍니다.*/ $t("MCOM-01-01-03-06")
          }}
        </div>
      </template>
    </modal-pop>
    <!-- 오류  안내-->
    <modal-pop :opened.sync="openedError" class="modal" confirm="MCOM-0000003">
      <template #content>
        <span v-html="errMsg"></span>
      </template>
    </modal-pop>
  </article>
</template>

<script>
import AccountDetailPopup from "@/components/page/accounts/AccountDetailPopup";
import TermiAnticiInq from "@/components/page/deposit/TermiAnticiInq";
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AccountBox",
  extends: Common,
  props: {
    acnList: {
      required: true,
    },
    page: {
      type: String,
      default: "",
    },
  },
  components: {
    AccountDetailPopup,
    TermiAnticiInq,
  },
  data() {
    return {
      openedError: false,
      errMsg: "",
      acnoInfo: {
        acno: "",
        currencyCd: "",
        acnoAls: "",
        acnOtPutNm: "",
        acnoKnd: "",
        acnDtailCd: "",
      },
      ntcInfo: {
        ntcKnd: "", // 공지 구분 (1: 계좌 상태 알림, 2: 만기 알림, 3: 대출 이자납부 알림, 4: 대출 만기 알림)
        val: [],
      },
      isOwbnkTrsacc: false,
      acnoAlrtOpened: false, // 계좌알림 팝업표기 여부
      trsaccOpend: false, // 이체 팝업표기 여부
      // userAcnNtcClosList: [],
      popupOpened: false,
      isExpirTermiBtn: "", //해지버튼 여부
      isExpirUpdatBtn: "", //갱신버튼 여부
      acno: "",
      cncycd: "",
      acnOtPutNm: "",
      acnoKnd: "",
      openedFatca: false,
    };
  },
  created() {},
  mounted() {
    // let natAcnNtcClosList = "";
    // natAcnNtcClosList = await this.$store.dispatch("native/actGetNativeData", "userAcnNtcClosList");
    // let list = [];
    // if (natAcnNtcClosList) {
    //   list = natAcnNtcClosList.split("_");
    // }
    // if (list != null && list.length > 0) {
    //   this.userAcnNtcClosList = list;
    //   this.$log.info(list)
    // }
  },
  computed: {
    ...mapFields("accounts", ["initAcno"]),
    ...mapFields("transfer", ["initDrwotAcno"]),
    ...mapFields("accounts/myAccounts", ["fatcaBilnTagetDstcd", "userAcnNtcClosList"]),
    ...mapFields("deposit/termiUpdat", ["depositTermi", "RBF0406H40", "RBF0404B40"]),
    ...mapGetters(["isPersonalUser", "isUserOtpDstcd", "isLogin"]),
    ...mapFields(["siteCode"]),
  },
  methods: {
    ...mapActions(["actSetLoading"]),
    goLoans(router, item) {
      this.$router.push({ name: router, params: item });
    },
    setAcnoInfo(item) {
      this.$set(this.acnoInfo, "acno", item.acno);
      this.$set(this.acnoInfo, "currencyCd", item.cncycd);
      this.$set(this.acnoInfo, "acnoAls", item.acnoAls);
      this.$set(this.acnoInfo, "acnOtPutNm", item.acnOtPutNm);
      this.$set(this.acnoInfo, "acnoKnd", item.acnoKnd);
      this.$set(this.acnoInfo, "acnDtailCd", item.acnDtailCd);
      this.isOwbnkTrsacc = item.isOwbnkTrsacc;
    },
    //계좌상세내역
    goAcnoDtl(item) {
      // this.acnoInfo.acno = item.acno;
      // this.acnoInfo.currencyCd = item.cncycd;
      this.isExpirTermiBtn = item.isExpirTermiBtn;
      this.isExpirUpdatBtn = item.isExpirUpdatBtn;
      this.setAcnoInfo(item);
      this.$refs.accountDetailPopup.RBF0404B40call(this.acnoInfo.acno, this.acnoInfo.acnoKnd, "0");
    },
    //거래내역조회
    goTrascDtl(item) {
      this.initAcno.acno = item.acno;
      if (item.acnoKnd2 == "3") {
        //입출금 거래내역조회
        this.$router.push({ name: "transactionDetails" });
      } else {
        //1,2,3:예금 4:적금 5:대출
        if (item.acnDtailCd == "4") {
          //적금 거래내역조회
          this.$router.push({ name: "instypFxdepTrnhis" });
        } else if (item.acnDtailCd == "5") {
          //대출 거래내역조회
          this.$router.push({ name: "lnAcnTrnhis" });
        } else {
          //예금 거래내역조회
          this.$router.push({ name: "dfstlFxdepTrnhis" });
        }
      }
    },
    //이체
    goTrsacc(trsaccKnd) {
      this.trsaccOpend = false;

      this.initDrwotAcno.acno = this.acnoInfo.acno;
      this.initDrwotAcno.cncycd = this.acnoInfo.currencyCd;
      this.initDrwotAcno.alias = this.acnoInfo.acnoAls;

      switch (trsaccKnd) {
        case "1": // 당행이체
          this.$router.push({ name: "trsaccInfoInptStep1" });
          break;
        case "2": // 타행이체
          if (this.siteCode == this.$config.SITECODE_OGHCM && this.isLogin && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03")) {
            this.$router.push({ name: "vtnOtrbnkTrsaccInfoInptReqStep1" });
          } else if (this.siteCode == this.$config.SITECODE_OGMMR && this.isLogin) {
            this.$router.push({ name: "cbmnetTrsaccInfoInptReqStep1" });
          } else {
            this.$router.push({ name: "otrbnkTrsaccInfoInptReqStep1" });
          }
          break;
      }
    },
    //해지예상조회
    async goAnticiInq(item) {
      this.acno = item.acno;
      this.cncycd = item.cncycd;
      this.acnOtPutNm = item.acnoAls;
      this.isExpirTermiBtn = item.isExpirTermiBtn;
      this.acnoKnd = item.acnoKnd;

      this.actSetLoading(true);
      if (await this.RBF0406D40Call(item)) {
        if (await this.RBF0404B40Ref(item)) {
          this.popupOpened = true;
        }
      }
      this.actSetLoading(false);
    },
    RBF0406D40Call(v) {
      /* API_RBF0406D40 - 예금해지예상조회 호출 */
      return new Promise(resolve => {
        this.$post(
          "/deposit/updat/TermiAnticiInq",
          {
            cncycd: v.cncycd, //해지통화코드
            trsaccKnd: 1, //해지예상조회여부
            acno: v.acno, //해지계좌번호
            termiYmd: this.moment().format("YYYYMMDD"), //해지일자
          },
          response => {
            this.$set(this.depositTermi, "expectation", response.outItem);
            resolve(true);
          },
          () => {
            resolve(false);
          },
          null,
          null,
          false,
        );
      });
    },
    async RBF0406D40Suc(res) {
      this.$set(this.depositTermi, "expectation", res.outItem);
      /* API_RBF0404B40 - 예금계좌상세조회 호출 */
      if (await this.RBF0404B40Ref({ acno: this.acno, acnoKnd: this.acnoKnd })) {
        this.popupOpened = true;
      }
    },
    //대출금상환
    goLnRpayamt(item) {
      this.setAcnoInfo(item);
      // alert("대출금상환");
    },
    closeNotice(ntcKnd, acno, val) {
      this.$set(this.acnoInfo, "acno", acno);
      this.$set(this.ntcInfo, "ntcKnd", ntcKnd);
      this.$set(this.ntcInfo, "val", val);

      this.acnoAlrtOpened = true;
    },
    closeNoticeCfm() {
      let fndIdx = this.acnList.findIndex(item => {
        return item.acno == this.acnoInfo.acno;
      });

      if (fndIdx > -1) {
        this.acnoAlrtOpened = false;
        this.setAcnNtcClose(fndIdx, this.ntcInfo.ntcKnd, this.acnoInfo.acno, this.ntcInfo.val);
      } else {
        this.acnoAlrtOpened = false;
        return;
      }
    },
    setAcnNtcClose(idx, ntcKnd, acno, val) {
      let acnNtcKey = this.createAcnNtcKey(ntcKnd, acno, val);

      if (this.ntcInfo.ntcKnd == "1") {
        this.acnList[idx].isAcnStusAlrmShow = false;
      } else if (this.ntcInfo.ntcKnd == "2") {
        this.acnList[idx].isExpirAlrmShow = false;
      } else if (this.ntcInfo.ntcKnd == "3") {
        this.acnList[idx].isNxtrmPaymtAlrmShow = false;
      } else if (this.ntcInfo.ntcKnd == "4") {
        this.acnList[idx].isLnExpirAlrmShow = false;
      }

      this.userAcnNtcClosList.push(acnNtcKey);

      //set native data
      this.$bridge.setNativeData({ natUserAcnNtcClos: this.userAcnNtcClosList.join("_") });
    },
    createAcnNtcKey(ntcKnd, acno, val) {
      /* 
      [공통] 공지구분 + @ + 계좌번호(acno) + @ + 추가정보 (1 + @ + 2 + .. @ + n)
      [추가정보]
       1. 계좌 상태 알림 : 계좌상태(acnStus)
       2. 만기 알림 : 만기일자(expirYmd)
       3. 대출 이자납부 : 차기이자납부일자(nxtrmPaymtYmd)
       4: 대출 만기 알림 : 대출만기일(lnExpirYmd)
      */
      let acnNtcKey = ntcKnd + "@" + acno;

      if (val != null && val.length > 0) {
        acnNtcKey +=
          "@" +
          val.reduce((a, b) => {
            return a + "@" + b;
          });
      }

      return acnNtcKey;
    },
    //갱신
    async reNew(v) {
      if (this.siteCode == this.$config.SITECODE_OGAUC) {
        this.openedError = true;
        this.errMsg = this.$t("P084-002"); // 해당 거래가 불가한 상태로 영업점에 문의바랍니다.
      } else {
        /* API_RBF0404B40 - 예금계좌상세조회 호출 */
        if (await this.RBF0404B40Ref(v)) {
          /* API_RBF0406H40 - 예금갱신예비 호출 */
          this.$post(
            "/deposit/updat/DpostUpdatStep3",
            {
              trsaccKnd: "1", //갱신예상조회여부
              tranYmd: v.expirYmd, //갱신일자
              acno: v.acno, //계좌번호
              cncycd: v.cncycd, //갱신계좌통화코드
              prdctName: v.acnoAls, //갱신계좌명
            },
            this.RBF0406H40Suc,
            null,
            null,
            null,
            false,
          );
        }
      }
    },
    RBF0404B40Ref(v) {
      /* API_RBF0404B40 - 예금계좌상세조회 호출 */
      return new Promise(resolve => {
        this.$post(
          "/account/inqury/AcnInqDtlPop",
          {
            acno: v.acno,
            acnDsticCd: v.acnoKnd,
            brncoEcrypPwdValdnYn: "0",
          },
          response => {
            this.RBF0404B40 = response.outItem;
            resolve(true);
          },
          () => {
            resolve(false);
          },
        );
      });
    },
    RBF0406H40Suc(res) {
      this.RBF0406H40 = {
        ...res.outItem,
      };
      this.$router.push({ name: "renewalStep1" });
    },
    //해지
    async termi(v) {
      if (await this.RBF0404B40Ref(v)) {
        if (this.RBF0404B40.acnStus == "1") {
          this.errMsg = this.$t(
            /*사고신고 상태에서는 해지를 하실 수 없습니다.<br/><br/>가까운 영업점을 방문하시어 사고신고 해제를 먼저하시고 계좌 해지를 진행해 주시기 바랍니다.*/ "MDEP-02-01-08-17",
          );
          this.openedError = true;
          return false;
        }

        let param = {
          termiYmd: this.moment().format("YYYYMMDD"),
          trsaccKnd: "1", //1:해지예상조회,0:예비거래
          acno: v.acno, //계좌번호
          cncycd: v.cncycd, //통화코드
        };
        this.$set(this.depositTermi, "acnoAls", v.acnoAls);
        /* API_RBF0406D40 - 예금해지예상조회 호출 */
        this.$post("/deposit/updat/TermiAnticiInq", param, this.termiSucc);
      }
    },
    termiSucc(res) {
      this.$set(this.depositTermi, "expectation", res.outItem);
      this.$router.push({ name: "termiStep1" });
    },
    popupClose() {
      this.popupOpened = false;
    },
    onTrsacc(data) {
      if (this.siteCode == this.$config.SITECODE_OGCBD) {
        this.goTrsacc("1");
      } else {
        this.trsaccOpend = true;
        this.setAcnoInfo(data);
      }
    },
    goToTermi() {
      let termi = {
        acno: this.acno,
        cncycd: this.cncycd,
        acnoAls: this.acnOtPutNm,
        acnoKnd: this.acnoKnd,
      };

      this.termi(termi);
    },
  },
};
</script>
